<template>
  <div v-if="payments.count > 0">
    <v-card flat class="factoring">
      <v-card-title class="d-block pa-0 mb-3">
        <p class="font--m-4 mb-2">송금 내역</p>
        <v-divider style="height: 2px"></v-divider>
      </v-card-title>
      <InfiniteList
        @intersect="loadPayments({ page: page++ })"
        :items="payments.results"
        :loading="loadPaymentsLoading"
        :off="infiniteOff"
      >
        <template slot-scope="{ item }">
          <RemittanceHistoryItem :item="item" :key="item.uuid" class="item" @reload="reload" />
        </template>
      </InfiniteList>
      <div
        v-if="payments.count < 1"
        class="justify-center text-center pt-10 pb-10 mb-10 mt-10 font--m-5"
      >
        송금 내역이 없습니다.
      </div>
    </v-card>
  </div>
  <div v-else class="d-flex align-center justify-space-between">
    <p class="mb-0 font--m-4">
      쇼핑몰 추가하고 <span class="font--m-4 font-weight-black">한도 UP</span>
    </p>
    <BasicButton
      id="btn__5FhzEqnEek2AeCJuAWAjcw=="
      width="85px"
      height="35px"
      :to="{ name: 'my/malls' }"
    >
      바로가기 >
    </BasicButton>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    InfiniteList: () => import('@/components/common/paging/InfiniteList.vue'),
    RemittanceHistoryItem: () => import('@/components/main/RemittanceHistoryItem.vue'),
  },
  data() {
    return {
      page: 1,
      pageSize: 30,
      loadPaymentsLoading: false,
      key: 0,
    }
  },
  computed: {
    ...mapState('choice', ['refreshTime']),
    ...mapState('bnpl', ['payments']),
    infiniteOff() {
      return this.payments?.next === null
    },
  },
  async created() {
    // 초기화 시키려고 사용
    await this.getPayments({
      page: this.page++,
      pageSize: this.pageSize,
    })
  },
  methods: {
    ...mapActions('bnpl', ['getPayments', 'getPaymentsAppend']),
    async loadPayments({ page }) {
      try {
        this.loadPaymentsLoading = true
        await this.getPaymentsAppend({
          page,
          pageSize: this.pageSize,
        })
      } catch (e) {
        if (e.status === 404) {
          return
        }
        throw e
      } finally {
        this.loadPaymentsLoading = false
      }
    },
    /**
     * 취소 후 목록 새로고침
     */
    async reload() {
      this.page = 1

      await this.getPayments({
        page: this.page++,
        pageSize: this.pageSize,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.factoring {
  padding-bottom: 20px;
}

table {
  width: 100%;
  tr {
    td {
      width: 60%;
      padding-bottom: 4px;
    }

    .money {
      text-align: right;
    }
  }
}
</style>
